import { ca } from '@cian/analytics';

import { getAllProducs } from './trackings';
import { ONE_PAGE_LENGTH } from '../constants/pagination';
import { EDeviceType } from '../types/device';
import { IPageState } from '../types/page';
import { IFavoriteEntity } from '../types/results';
import { TUser } from '../types/user';

export enum EFavoritePageType {
  Offer = 'offer',
  Newbuilding = 'newbuilding',
  Houses = 'houses',
  Savedsearch = 'savedsearch',
}

export interface ITrackPageviewProps {
  pageData: IPageState;
  user: TUser;
  favoritePageType: EFavoritePageType;
  favoriteEntities?: IFavoriteEntity[];
  total?: number;
  skipCount?: number;
}

export function trackPageview({
  pageData,
  user,
  favoritePageType,
  favoriteEntities,
  total,
  skipCount,
}: ITrackPageviewProps) {
  ca('pageview', {
    category: 'page',
    action: 'newpage',
    name: 'newpage',
    label: 'open',
    ...getPageviewData({ pageData, user, favoritePageType, favoriteEntities, total, skipCount }),
  });
}

export interface IPageviewDataProps {
  pageData: IPageState;
  user: TUser;
  favoritePageType: EFavoritePageType;
  favoriteEntities?: IFavoriteEntity[];
  total?: number;
  skipCount?: number;
}

export function getPageviewData({
  pageData,
  user,
  favoritePageType,
  favoriteEntities,
  total,
  skipCount,
}: IPageviewDataProps) {
  const pageNumber = (favoriteEntities && Math.ceil(favoriteEntities.length / ONE_PAGE_LENGTH)) || 1;

  return {
    user: {
      isAuthorized: user.isAuthenticated,
      userId: user.isAuthenticated ? user.userId : undefined,
    },
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber,
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: pageData.deviceType !== EDeviceType.Phone ? pageData.deviceType : 'mobile',
      extra: {
        favorite_pagetype: favoritePageType,
      },
    },
    ...(favoriteEntities && { products: getAllProducs({ favoriteEntities, pageNumber, skipCount }) }),
  };
}
